export default {
  notifications: null,
  notificationAdded: null
}
